import React, { Component } from "react";
import { Link } from "react-router-dom";
import HeaderSubPart from "../HeaderSubPart/HeaderSubPart";
import styles from "../../components/Header/Header.module.scss";

let E3_Logo = require("../../assets/images/E3_Logo.png");
let insurecomplogo = require("../../assets/images/new-logo.png");

// let isMobile = window.innerWidth < 900;

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logoSize: "large",
      isMobile: window.innerWidth < 900,
    };
  }

  // Lifecycle method to add the resize event listener
  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  // Clean up the event listener when the component unmounts
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  // Method to handle window resizing and update the state
  handleResize = () => {
    this.setState({ isMobile: window.innerWidth < 900 });
  };

  render() {
    let { logoSize, isMobile } = this.state;

    return (
      <>
        <nav
          id="navbarMain"
          className={
            this.props.loggedInUser === undefined
              ? `${styles.new_navbar} container-fluid  ${styles.nav_fontsize}`
              : `${styles.new_navbar_login} container-fluid  ${styles.nav_fontsize}`
          }
        >
          <div className="d-flex justify-content-between align-items-center w-100 no-gutters">
            {
              <img
                className={styles.imagesizelogo}
                id="imagesizelogo"
                style={
                  logoSize === "large"
                    ? {
                        height: "100px",
                        marginLeft: "2rem",
                        marginTop: "1rem",
                      }
                    : { height: "100px", marginLeft: "1.6rem" }
                }
                src={E3_Logo}
                alt="libertate logo"
              />
            }
            {/**process.env.REACT_APP_MODE === "prod" ? (
              // <Link
              //   to={"/"}
              //   className="navbar-brand mx-0 d-flex align-items-center navlisting"
              // >
              <img
                className={styles.imagesizelogo}
                id="imagesizelogo"
                style={
                  logoSize === "large"
                    ? {
                        height: "100px",
                        marginLeft: "2rem",
                        marginTop: "1rem",
                      }
                    : { height: "100px", marginLeft: "1.6rem" }
                }
                src={E3_Logo}
                alt="libertate logo"
              />
            ) : (
              // </Link>
              <div></div>
            )**/}

            {isMobile ? (
              " "
            ) : (
              <HeaderSubPart sessionData={this.props.sessionData} />
            )}

             <Link
              to={"/"}
              className={`navbar-brand mx-0 d-flex align-items-center ${styles.icomplink}`}
               onClick={(e) => {
             e.preventDefault(); 
             const protocol = window.location.protocol; 
             const targetHost = "www.insurecomp.com"; 
             const targetUrl = `${protocol}//${targetHost}`;
             window.location.href = targetUrl; 
                  }}
            > 
            <img
              className={styles.imagesizelogoicomp}
              id="imagesizelogoicomp"
              style={
                logoSize === "large"
                  ? {
                      height: "70px",
                      marginRight: "2rem",
                    }
                  : {
                      height: "71px",
                      marginRight: "1rem",
                    }
              }
              src={insurecomplogo}
              alt="insurecomp logo"
            />
            </Link> 
          </div>
        </nav>
      </>
    );
  }
}

export default Header;
